import { forwardRef } from 'react';

import clsx from 'clsx';

import { TendencyIcon, TendencyIconProps } from '../../TendencyIcon';

import { Typography, Box } from '@cast/design-system';
import type { TypographyProps } from '@cast/design-system';

type TendencyIndicatorProps = TendencyIconProps & {
  value: string;
  valueProps?: TypographyProps;
};

export const TendencyIndicatorBase = forwardRef<
  HTMLDivElement,
  TendencyIndicatorProps
>((props: TendencyIndicatorProps, ref) => {
  const { value, className, valueProps, ...iconProps } = props;

  return (
    <Box
      display="inline-flex"
      alignItems="center"
      component="span"
      className={clsx(`Tendency-${props.tendency}`, className)}
      ref={ref}
    >
      {iconProps.tendency !== 'stable' ? (
        <TendencyIcon className="TendencyIndicator-icon" {...iconProps} />
      ) : null}
      <Typography
        className="TendencyIndicator-label"
        component="span"
        color="inherit"
        ml={
          iconProps.tendency !== 'stable'
            ? `${(iconProps.size ?? 14) / 3}px`
            : 0
        }
        variant="P14R"
        {...valueProps}
      >
        {value}
      </Typography>
    </Box>
  );
});

TendencyIndicatorBase.displayName = 'TendencyIndicatorBase';
